import {
  colors,
  customEvent,
  getCdnImageSrc,
  getPrimeUrl,
  HLine,
  HomeCard,
  NextLink,
  setVisitedFeature,
  Spacing,
  VStack,
} from "goi_common";
import useIntersectionObserver from "goi_common/src/hooks/useIntersectionObserver";
import { useEffect, useRef } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

import { isViewportTopState } from "../../atoms/viewportTopState";
import { useRouter } from "next/router";
import { scrollYState } from "./atoms/scrollYState";

import { HeroSection } from "./components/RenewalVersion/HeroSection";
import { SelectedAndReviewAndGuideSection } from "./components/RenewalVersion/SelectedAndReviewAndGuideSection";
import { StandBy24Hours } from "./components/StandBy24Hours";
import GoiMessage from "./components/GoiMessage";
import RenewalFooter from "./components/RenewalFooter";
import HomeLayout from "@/components/Layout/HomeLayout/HomeLayout";
import { Box, Button } from "@chakra-ui/react";
import { ImageSlider } from "@/components/ImageSlider";
// import { useOffDirectCall } from "@/hooks/useOffDirectCall";
// import { useBannerDisclosure } from "../BenefitContainer/components/useBannerDisclosure";
// import { BenefitBanner } from "../BenefitContainer/components/Benefit20Banner";

export default function HomeContainer({ name }: { name: string }) {
  useEffect(() => {
    setVisitedFeature("home");
    localStorage.setItem("home-router", "");
  }, []);

  const viewportTopRef = useRef<HTMLDivElement>(null);
  const setIsViewportTop = useSetRecoilState(isViewportTopState);

  // const { isOpen, handleClose } = useBannerDisclosure({
  //   storageKey: "benefit-banner-closed",
  //   event: {
  //     path: "home",
  //     trigger_and_target: "benefit_banner_close",
  //   },
  // });

  useIntersectionObserver({
    root: null,
    target: viewportTopRef,
    onIntersect: () => {
      setIsViewportTop(true);
    },
    onNotIntersect: () => {
      setIsViewportTop(false);
    },
    rootMargin: "30px 0px",
  });

  const router = useRouter();
  const [scrollYPostion, setScrollYPosition] = useRecoilState(scrollYState);

  const handleSetScrollY = () => {
    setScrollYPosition(window.scrollY);
  };

  useEffect(() => {
    window.scrollTo(0, scrollYPostion);
    setScrollYPosition(0);
  }, []);

  useEffect(() => {
    router.events.on("routeChangeStart", handleSetScrollY);
    return () => {
      router.events.off("routeChangeStart", handleSetScrollY);
    };
  }, []);

  // const isOffDirectCall = useOffDirectCall();
  // const onClickBenefitBanner = () => {
  //   customEvent({
  //     newGtm: {
  //       path: "home",
  //       trigger_and_target: "benefit_banner_click",
  //     },
  //   });

  //   router.push("/campaign/benefit_20/");
  // };

  const HOME_BANNER_SLIDE_ITEMS = [
    {
      href: getPrimeUrl("/memorialtable/"),
      imageSrc: "platform/home/memorial_table_banner_1.png",
      triggerAndTarget: "memorialtable_banner_click" as const,
    },
    {
      href: "/promotion/jangji/general/?utm_source=home",
      imageSrc: "platform/promotion/jangji/general_banner_1.png",
      triggerAndTarget: "jangji_banner_click" as const,
    },
  ];

  return (
    <HomeLayout>
      <VStack maxWidth="480px" background="white" width="100%" /* alignItems="center" */>
        {/* <HomeStepGuideFooter
          iconMarginLeft="30px"
          bottom={"80px"}
          right={"0px"}
          event={{ newGtm: { path: "home", trigger_and_target: "step_guide_fixed_button" } }}
        /> */}
        <div ref={viewportTopRef}></div>
        {/* {isOpen && (
          <Box padding="20px 20px 0px 20px">
            <BenefitBanner onClick={onClickBenefitBanner} onClose={handleClose} />
          </Box>
        )} */}
        {/* {!isOffDirectCall && ( */}
        <Box padding="20px 20px 0px 20px">
          <ImageSlider
            slideItems={HOME_BANNER_SLIDE_ITEMS}
            eventPath="home"
            aspectRatio="640/368"
          />
        </Box>
        {/* )} */}

        <HeroSection />

        <VStack padding="56px 20px" gap={0}>
          <Box className="subtitle_21_sb gray900">주변 장례 시설 정보 확인하기</Box>
          <Spacing gap={8} />
          <Box className="body_16_r gray700">
            지역과 비용, 편의시설 등 원하는 조건의
            <br />
            장례식장, 화장장, 장지 정보를 확인해 보세요
          </Box>
          <Spacing gap={20} />
          <NextLink
            href="/funeral-facilities/"
            event={{
              newGtm: { path: "home", trigger_and_target: "facility-uv_list" },
            }}
          >
            <Box
              background="#3F4C61"
              borderRadius="12px"
              overflow="hidden"
              position="relative"
              height="256px"
              width="100%"
            >
              <Box
                as="img"
                src="/platform/home/facility_entry_building.png"
                alt=""
                width="calc(100% - 48px)"
                maxWidth="272px"
                height="164px"
                margin="24px auto 0"
                display="block"
                objectFit="contain"
              />
              <Box
                position="absolute"
                left="50%"
                bottom="20px"
                transform="translateX(-50%)"
                width="calc(100% - 48px)"
                maxWidth="272px"
                height="40px"
                background="white"
                borderRadius="6px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                className="body_14_m"
                color="#252525"
              >
                자세히 알아보기
              </Box>
            </Box>
          </NextLink>
        </VStack>

        {/* <FuneralPrepareBannerSection path="home" /> */}
        <SelectedAndReviewAndGuideSection />

        <VStack padding="56px 20px" gap={0}>
          <Box className="subtitle_21_sb gray900">장례 준비가 처음이라면</Box>
          <Spacing gap={20} />

          <NextLink
            href="/funeral-prepare/1"
            event={{
              newGtm: { path: "home", trigger_and_target: "content-uv_prepare_1" },
            }}
          >
            <HomeCard
              imageSrc={getCdnImageSrc("platform/home/match.png")}
              title={`처음하는 장례 준비\n어떻게 해야 후회 없을까요?`}
              buttonText="장례 준비의 A to Z"
            />
          </NextLink>
          <Spacing gap={16} />

          <NextLink
            href="/funeral-prepare/2"
            event={{
              newGtm: { path: "home", trigger_and_target: "content-uv_prepare_2" },
            }}
          >
            <HomeCard
              imageSrc={getCdnImageSrc("platform/home/comparison.png")}
              title={`선불? 후불?\n나에게 맞는 서비스 찾기`}
              buttonText="선불/후불 비교하기"
            />
          </NextLink>
          <Spacing gap={120} />
          <Box className="subtitle_21_sb gray900">
            가입 상품으로
            <br />
            장례 비용을 아껴보세요
          </Box>
          <Spacing gap={20} />
          <NextLink
            event={{
              newGtm: {
                path: "home",
                trigger_and_target: "banner_CTA-uv_prime",
              },
            }}
            href={getPrimeUrl("/")}
          >
            <HomeCard
              imageSrc={getCdnImageSrc("platform/home/coin.png")}
              title={`미리 준비하는 장례\n월 100원으로 충분해요`}
              buttonText="100원 상조 알아보기"
            />
          </NextLink>
          <Spacing gap={104} />

          <Box className="subtitle_21_sb gray900">고이의 변하지 않는 약속</Box>
          <Spacing gap={8} />
          <Box className="body_16_r gray700">장례를 장례답게 만들기 위한 최소한의 원칙이에요</Box>
          <Spacing gap={20} />
          <HomeCard
            title={`품목별 가격 정찰제`}
            buttonText="업계 최초로 모든 품목에 가격 정찰제를 도입하여 실제로 사용한 품목만 비용만 받습니다."
          />
          <Spacing gap={12} />

          <HomeCard
            title={`사용하지 않는 품목 100% 공제`}
            buttonText="패키지 내 사용하지 않은 품목에 대해 명시된 금액만큼 100% 현금으로 공제해 드립니다."
          />
          <Spacing gap={12} />

          <HomeCard
            title={`서비스 불만족시 100% 환불`}
            buttonText="고이는 장례 용품 강매, 노잣돈 및 수고비 강요와 같은 부적절한 행위를 엄격히 금지하고 있으며 불만족스러운 부분은 100% 환불해 드립니다."
          />
          <Spacing gap={24} />
          <Button
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "home",
                  trigger_and_target: "goi_service-uv_service",
                },
              });
              router.push("/service/");
            }}
            border={`1px solid ${colors.gray100}`}
            borderRadius="12px"
            background={colors.white}
            padding="12px 0"
            className="body_16_m gray900"
          >
            고이 표준 서비스 바로가기
          </Button>
          <Spacing gap={120} />
        </VStack>
        {/* <GoiService /> */}
        <StandBy24Hours />
        <Spacing gap={16} />
        <GoiMessage />
        <HLine height="1px" color={colors.gray200} />
        <RenewalFooter />
      </VStack>
    </HomeLayout>
  );
}
